import React, { useRef, useEffect, useState } from "react";
import { Cylinder } from "@react-three/drei";
import useTransitionStore from "../../../../state/transitions";
import Platform from "./Platform";

const CarFlipPlatform = () => {
  const box = useRef();
  const [visible, setVisible] = useState(true);
  const DayMode = useTransitionStore((s) => s.DayMode);
  const DisplayMode = useTransitionStore((s) => s.DisplayMode);
  const setDisableDayModeToggle = useTransitionStore(
    (s) => s.setDisableDayModeToggle
  );

  useEffect(() => {
    if (!visible) {
      if (DayMode === "night" || DisplayMode === "flipper") {
        setTimeout(() => {
          setVisible(true);
          setDisableDayModeToggle(false);
        }, 1500);
      }
    } else if (DayMode === "day" || DisplayMode === "!flipper") {
      setVisible(false);
      setTimeout(() => {
        setDisableDayModeToggle(false);
      }, 1500);
    }
  }, [DayMode, DisplayMode]);

  return (
    <group visible={visible}>
      <mesh
        ref={box}
        position={[0, 0, 0]}
        rotation={[Math.PI / 2, 0, Math.PI / 2]}
        // position={[0, 1.5, 0]}
        // rotation={[0, Math.PI / 2, 0]}
      >
        <Platform />
      </mesh>
      <mesh
        scale={0.9}
        position={[0, 0, 0]}
        rotation={[Math.PI / 2, 0, Math.PI / 2]}
      >
        <Cylinder args={[3.15, 3.15, 15, 3, 1]}>
          <meshBasicMaterial transparent={false} color={"#000"} />
        </Cylinder>
      </mesh>
    </group>
  );
};

export default React.memo(CarFlipPlatform);
